import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThemoviedatabaseComponent } from './simple-icons-themoviedatabase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThemoviedatabaseComponent ],
    exports:      [ SimpleIconsThemoviedatabaseComponent ],
    bootstrap:    []
})
export class SimpleIconsThemoviedatabaseModule {}
